export const LEGACY_FONT_STYLE_KEY = "hlwFont";
export const OVERRIDE_FONT_STYLE_KEY = "hlwFontStyle";
export const OVERRIDE_LETTER_SPACING_KEY = "hlwLetterSpacing";
export const OVERRIDE_WORD_SPACING_KEY = "hlwWordSpacing";
